import { Container, Title, Text } from '@mantine/core'

export function PracticeSession() {
  return (
    <Container>
      <Title order={2} c="var(--sat-text)">Practice Session</Title>
      <Text c="var(--sat-green)" mt="md">Coming soon</Text>
    </Container>
  )
}
